import {
  Database as DatabaseIcon,
  Shield as ShieldIcon,
  AlertTriangle as AlertTriangleIcon,
} from 'react-feather'

import theme from 'theme'

const NECESSARY_ID = 3
const ANALYTICAL_PERFORMANCE_ID = 5
const FUNCTIONALITY_ID = 6
const ADVERTISING_ID = 7
const UNKNOWN_ID = 10

const NECESSARY_LABEL = 'Necessários'
const ANALYTICAL_PERFORMANCE_LABEL = 'Analíticos ou de desempenho'
const FUNCTIONALITY_LABEL = 'Funcionalidade'
const ADVERTISING_LABEL = 'Publicidade'
const UNKNOWN_LABEL = 'Outros'

const ANALYTICAL_PERFORMANCE_KEY = 'analytics'
const FUNCTIONALITY_KEY = 'functionality'
const ADVERTISING_KEY = 'advertising'
const UNKNOWN_KEY = 'unknown'

const SECURITY_STORAGE_TYPE = 'security_storage'
const ANALYTICAL_PERFORMANCE_TYPE = 'analytics_storage'
const FUNCTIONALITY_TYPE = 'functionality_storage'
const ADVERTISING_TYPE = 'ad_storage'

const VALID_CATEGORIES = [
  NECESSARY_ID,
  ANALYTICAL_PERFORMANCE_ID,
  FUNCTIONALITY_ID,
  ADVERTISING_ID,
]

const AUTO_BLOCK_FIXED_CATEGORIES = [
  FUNCTIONALITY_KEY,
  ANALYTICAL_PERFORMANCE_KEY,
  ADVERTISING_KEY,
]

const AUTO_BLOCK_SWITCHES = [
  {
    name: 'autoBlockCategorized',
    label: 'Bloquear cookies categorizados automaticamente',
    description: `Cookies de ${FUNCTIONALITY_LABEL}, ${ANALYTICAL_PERFORMANCE_LABEL} e ${ADVERTISING_LABEL} ficam bloqueados até o visitante consentir.`,
  },
  {
    name: 'autoBlockUnknown',
    label: 'Bloquear cookies não categorizados automaticamente',
    description: `Cookies da categoria ${UNKNOWN_LABEL}, que o scanner não reconheceu. Bloqueá-los pode comprometer o funcionamento do site.`,
  },
]

const CONSENT_DEFAULT_DENIED = 'denied'
const CONSENT_DEFAULT_GRANTED = 'granted'

const CONSENT_DEFAULT_OPTIONS = [
  { value: CONSENT_DEFAULT_DENIED, label: 'Negado' },
  { value: CONSENT_DEFAULT_GRANTED, label: 'Concedido' },
]

const CONSENT_MODE_TITLE = 'Opções avançadas: Google Consent Mode'

const CONSENT_MODE_DESCRIPTION =
  'Define o que o banner informa ao Google antes de o visitante escolher. Com "Negado", o Google Analytics e o Google Ads só usam cookies daquela categoria depois do aceite. Esta opção não substitui o bloqueio de cookies do banner: ela só orienta as ferramentas do Google.'

const CONSENT_DEFAULT_ROWS = [
  {
    key: FUNCTIONALITY_KEY,
    name: FUNCTIONALITY_LABEL,
    grantedNote:
      'A ANPD sugere desativar por padrão os cookies que dependem de consentimento e deixar ativos só os necessários ao funcionamento do site (Guia de Cookies da ANPD, p. 32 e 33).',
  },
  {
    key: ANALYTICAL_PERFORMANCE_KEY,
    name: ANALYTICAL_PERFORMANCE_LABEL,
    grantedNote:
      'A ANPD sugere manter desativados por padrão os cookies não necessários. Para a medição de audiência sem consentimento, ela sugere dados agregados, anônimos e não compartilhados com terceiros. Ferramentas como o Google Analytics enviam os dados a um terceiro (Guia de Cookies da ANPD, p. 26 e 33).',
  },
  {
    key: ADVERTISING_KEY,
    name: ADVERTISING_LABEL,
    grantedNote:
      'A ANPD sugere usar o consentimento do visitante para cookies de publicidade (Guia de Cookies da ANPD, p. 25 e 33).',
  },
]

const CONSENT_DEFAULT_CATEGORIES = [
  FUNCTIONALITY_KEY,
  ANALYTICAL_PERFORMANCE_KEY,
  ADVERTISING_KEY,
]

const MENU_ITEMS = [
  {
    id: NECESSARY_ID,
    name: NECESSARY_LABEL,
    translateKey: 'menu.cookieSection.necessary.title',
    alwaysActive: true,
  },
  {
    id: FUNCTIONALITY_ID,
    name: FUNCTIONALITY_LABEL,
    translateKey: 'menu.cookieSection.functionality.title',
  },
  {
    id: ADVERTISING_ID,
    name: ADVERTISING_LABEL,
    translateKey: 'menu.cookieSection.marketing.title',
  },
  {
    id: ANALYTICAL_PERFORMANCE_ID,
    name: ANALYTICAL_PERFORMANCE_LABEL,
    translateKey: 'menu.cookieSection.analytics.title',
  },
  {
    id: UNKNOWN_ID,
    name: UNKNOWN_LABEL,
    translateKey: 'menu.cookieSection.others.title',
  },
]

const STORAGE_TYPES = {
  [NECESSARY_ID]: SECURITY_STORAGE_TYPE,
  [ANALYTICAL_PERFORMANCE_ID]: ANALYTICAL_PERFORMANCE_TYPE,
  [FUNCTIONALITY_ID]: FUNCTIONALITY_TYPE,
  [ADVERTISING_ID]: ADVERTISING_TYPE,
  [UNKNOWN_ID]: '', // Categoria desconhecida não tem storage type específico
}

const COOKIE_STATS_CONFIG = [
  {
    key: 'total',
    icon: DatabaseIcon,
    label: 'Total de Cookies',
    backgroundColor: theme.palette.info.light,
  },
  {
    key: 'classified',
    icon: ShieldIcon,
    label: 'Cookies Classificados',
    backgroundColor: theme.palette.success.light,
  },
  {
    key: 'unknown',
    icon: AlertTriangleIcon,
    label: 'Cookies Não Classificados',
    backgroundColor: theme.palette.warning.light,
  },
]

const categories = {
  ADVERTISING_ID,
  ANALYTICAL_PERFORMANCE_ID,
  AUTO_BLOCK_FIXED_CATEGORIES,
  AUTO_BLOCK_SWITCHES,
  CONSENT_DEFAULT_CATEGORIES,
  CONSENT_DEFAULT_DENIED,
  CONSENT_DEFAULT_GRANTED,
  CONSENT_DEFAULT_OPTIONS,
  CONSENT_DEFAULT_ROWS,
  CONSENT_MODE_DESCRIPTION,
  CONSENT_MODE_TITLE,
  COOKIE_STATS_CONFIG,
  FUNCTIONALITY_ID,
  MENU_ITEMS,
  NECESSARY_ID,
  STORAGE_TYPES,
  UNKNOWN_ID,
  UNKNOWN_KEY,
  VALID_CATEGORIES,
}

export default categories
